<template>
    <tbody>
        <tr
            v-for="item in requestUniforms"
            :key="item.id"
        >
        <td>{{ item.title }}</td>
        <td class="form-control">
            <div class="form-group form-group-2 mb-0">
                <b>{{ item.size }}</b>
            </div>
        </td>
        <td>
            <div class="form-group form-group-2 mb-0">
                <b>{{ item.quantity }}</b>
            </div>
        </td>
        <td>
            <div class="action-block">
                <button
                    class="delete-link "><img
                    src="/img/svg/on.svg" alt=""
                    @click="removeItem(item)"
                ></button>
            </div>
        </td>
    </tr>
        <tr class="new-item-row" v-if="showInput">
        <td>
            <div class="form-group form-group-2 mb-0">
                <input type="text" class="form-control"
                       placeholder="Type Inventory Name "
                       v-model="searchTerm"
                       @input="handleSearch"
                >
                <ul
                    v-show="showResults"
                    class="search-results"
                >
                    <li v-for="(result, index) in filteredUniformsList"
                        :key="index"
                        @click="selectResult(result)">
                        {{ result.title }}
                    </li>
                </ul>
            </div>

        </td>
        <td>
            <div class="form-group form-group-2 mb-0">
                <input type="text" class="form-control" v-model="uniform.size">
            </div>
        </td>
        <td>
            <div class="form-group form-group-2 mb-0">
                <input
                    type="number"
                    class="form-control"
                    min="0"
                    v-model.number="uniform.quantity"
                >
            </div>
        </td>
        <td>
            <div class="action-block">
                <button
                    class="edit-link" @click="saveItem"
                >
                    <img src="/img/svg/check-5.svg" alt="Save">
                </button>
            </div>
        </td>
    </tr>
    </tbody>

</template>

<script>
import _ from "lodash";
import UniformsService from "./service/UniformsService";

export default {
    name: 'InventoryItemInRequest',
    emits: ['update-uniforms','remove-item'],
    props: {
        showInput: Boolean
    },
    data() {
        return {
            uniform: {
                size: null,
                quantity: null,
            },
            filteredUniformsList: [],
            showResults: true,
            searchTerm: '',
            foundUniform: null,
            requestUniforms: []
        }
    },
    methods: {
        handleSearch() {
            this.delayedSearch();
        },
        delayedSearch: _.debounce(function () {
            this.searchUniformItem()
        }, 500),

        removeItem(item) {
            this.requestUniforms = this.requestUniforms.filter(uniform => uniform.uniform_id !== item.uniform_id);
            this.$emit('update-uniforms', this.requestUniforms)
        },
        async saveItem() {
            if (!this.uniform.quantity) {
                this.$showErrorMessage('It is impossible to save without quantity')
                return
            }
            if (this.filteredUniformsList.includes(this.foundUniform)) {
                await this.addExistingUniform(this.foundUniform);
            } else if (!this.searchTerm || this.searchTerm.trim() === '') {
                this.$showErrorMessage('It is impossible to save without uniform title. Please select from list or create new item')
            } else {
                await this.createNewUniform(this.searchTerm);
            }
        },
        selectResult(result) {
            this.foundUniform = result
            this.searchTerm = result.title
            this.showResults = false
        },
        async searchUniformItem() {
            if (this.searchTerm !== null && this.searchTerm !== '') {
                this.showResults = true
                try {
                    const {data: response} = await UniformsService.searchUniformInList(this.searchTerm)
                    this.filteredUniformsList = response.data
                } catch (e) {
                }
            }
        },
        async addExistingUniform(uniform) {

            this.requestUniforms.push({
                title: uniform.title,
                uniform_id: uniform.id,
                size: this.uniform.size,
                quantity: this.uniform.quantity,
            });
            this.$emit('update-uniforms', this.requestUniforms)
            this.$showSuccessMessage('Item has been added')
            this.showTypeInput = false
            this.searchTerm = null
            this.uniform.size = null
            this.uniform.quantity = null

        },
        async createNewUniform(newUniformTitle) {
            try {
                const {data: uniform} = await UniformsService.addNewUniformItem(newUniformTitle);
                await this.addExistingUniform(uniform)
            } catch (error) {
                console.error(error);
                this.$showErrorMessage('The server could not save the new position. Please try again or create via the toolbar.')
            }
        },

    },

}

</script>

<style scoped>
.search-results {
    list-style: none;
    margin: 0;
    padding: 0;
    width: 100%;
    background-color: #fff;
    border: 1px solid #ddd;
    border-top: none;
    z-index: 9999;
    border-radius: 5px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    max-height: 120px;
    overflow-y: auto;
}

.search-results li {
    border-bottom: 1px solid #ddd;
    padding: 10px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.search-results li:hover {
    background-color: #0d2d53;
    color: white;
    border-radius: 5px;

}


</style>
